
$(document).ready(function() {
	//Dynamically load months

	buildDates('#'+type);
	$("option:selected").removeClass('selected');
	$("#"+type+" option").filter('.empty-opt').each(function(){
		var id = $(this).parent().attr('id');
		if( id != 'cruise-meta' && id != 'noOfPax' ){
			$(this).attr('selected','selected');
		}
	});
	$(".selected").removeClass('selected');
	$('#cruise-meta option').each(function(){
		if($(this).val() == defaultMeta){
			$(this).attr('selected','selected');
		}
	});
	$('#noOfPax option').eq(1).attr('selected','selected');
	
	$("#cruised-with-princess").click( function(){
		setCookie('cwp', $(this).is(':checked') ? 'true' : 'false');
		//document.cookie = 'cwp' + "=" + escape($(this).is(':checked') ? 'true' : 'false') + "; " + "path=/; domain=localhost; ";
	})
	
	$("#"+type+" select").not('#cruise-meta, #noOfPax').change( function() {
		$(".selected", this).removeClass('selected');
		$("option:selected", this).addClass('selected');
		sendQuery( update, type );
	});
	$('div.results').css('cursor','pointer').live('click', function(){
		viewDetails();
		return false;
	})
	

	setClick(type);
	getData( update, type );
});

function update( xml, type ){
//console.log('simple - update:type='+type);	
	
	var choices = $("#"+type+" li");
	var choicesOpt = $("#"+type+" option").not(".empty-opt");
	
	if( $.browser.msie || $.browser.safari || $.browser.chrome ){
		choicesOpt.showOption();
	}
	choices.removeClass('default disabled');
	choicesOpt.removeClass('default disabled');

			
	$(xml).find('cruisedata M').each(function(){ // Highlighting
		theContent = $(this).text();
		$('#'+theContent).addClass('default').show();

	});
	
	//Disable those that do not have any cruise			
	choices.not(".default").addClass('disabled'); 	
	choicesOpt.not(".default").hide();
	if( $.browser.msie || $.browser.safari || $.browser.chrome  ){
		choicesOpt.not(".default").hideOption();	
	} 
	
	choices.filter(".selected.disabled").removeClass('selected'); //Can't be "selected" and "disabled"
}


function clearAll(){ //Clear Button Action
	$('#'+type+' li, #'+type+' input, #'+type+' option').removeClass('selected default');
	$("#"+type+" select").each(function(){
		$(this).children().attr("selected",false);
		$(this).children().eq(0).attr("selected",true);
	});
	clearQueryParams();
	sendQuery( update, type );
}
